export const activate = (scrollPosition, isMenu) => {
    document.body.style.position = 'fixed';
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.height = '100%';
    const iframe = document.getElementById('c9-iframe');
    if(isMenu && iframe) {
      iframe.style.pointerEvents = "none"; 
    }
  };
  
  export const deactivate = (scrollPosition, isMenu) => {
    document.body.removeAttribute('style');
    document.documentElement.removeAttribute('style');
    window.scrollTo(0, scrollPosition);
    
    const iframe = document.getElementById('c9-iframe');
    if(isMenu && iframe) {
      iframe.style.pointerEvents = "auto";
    }
  };
  
